import styled from "styled-components";

import { Switcher } from "@similarweb/ui-components";

export const StyledCrmEnrichmentJobSwitcher = styled(Switcher)`
    span {
        width: 100%;
        line-height: 40px;
    }
`;
